// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip_2He3T","tooltiptext":"tooltiptext_5rNoH","cellHighlight":"cellHighlight_1ZSnP","rowColLabel":"rowColLabel_2MiU6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/gameboard/minefield/style.scss
// module id = 219
// module chunks = 0